import Info from 'components/shared/Info'
import Link from 'components/shared/Link'
import Text from 'components/shared/Text'
import { PRICING_LINK } from 'constants/links'
import { FormattedMessage } from 'react-intl'

type CalendarEarlyPurchaseInfoProps = {
    hasDarkMode?: boolean
}

const CalendarEarlyPurchaseInfo = ({
    hasDarkMode,
}: CalendarEarlyPurchaseInfoProps) => {
    const fontVariant = 'bodySmall'

    return (
        <Info
            color="success"
            {...(hasDarkMode && {
                hasNoBackground: true,
                hasBorder: true,
                borderColor: 'success',
            })}
        >
            <Text
                variant={fontVariant}
                color={hasDarkMode ? 'grayscale_400' : 'grayscale_900'}
            >
                <FormattedMessage
                    id="global.modal.calendar_legend_early_purchase"
                    defaultMessage="Oszczędź 20 zł na każdym bilecie kupując 14+ dni wcześniej lub 10 zł kupując 1-13 dni wcześniej! <link>Cennik</link>"
                    values={{
                        link: (chunks: string[]) => (
                            <Link
                                path={PRICING_LINK}
                                target="_blank"
                                variant={hasDarkMode ? 'primary' : 'secondary'}
                                icon={null}
                                textVariant={fontVariant}
                                data-testid="ticket-calendar-legend-link-pricing"
                            >
                                {chunks}
                            </Link>
                        ),
                    }}
                />
            </Text>
        </Info>
    )
}

export default CalendarEarlyPurchaseInfo
